import { DEFAULT_FLOOR_SIZE, MIN_ELEMENT_SIZE } from 'editor'
import type { FloormapConfig } from 'features/editor'
import { GRID_STEP } from 'features/floorMap/floorMap.config'

export const snap = (value: number) => Math.round(value / GRID_STEP) * GRID_STEP

const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(value, max))

export const clampSize = (value: number, max: number) =>
	Math.max(MIN_ELEMENT_SIZE, Math.min(Math.round(value), max))

export const getFloorSize = (config: FloormapConfig) => {
	const floor = config.find((element) => element.type === 'floorDimentions')

	return floor?.type === 'floorDimentions'
		? { width: +floor.width, height: +floor.height }
		: DEFAULT_FLOOR_SIZE
}

export const keepInside = (node: any) => {
	const stage = node.getStage()
	const box = node.getClientRect({ skipStroke: true })
	const offsetX = box.x - node.x()
	const offsetY = box.y - node.y()

	return {
		x: clamp(snap(node.x()), -offsetX, stage.width() - box.width - offsetX),
		y: clamp(snap(node.y()), -offsetY, stage.height() - box.height - offsetY)
	}
}

export const resizeInside = (node: any, isCircle = false) => {
	const stage = node.getStage()
	const box = node.getClientRect({ skipStroke: true })
	const x = snap(box.x)
	const y = snap(box.y)
	const maxWidth = stage.width() - x
	const maxHeight = stage.height() - y
	const width = clampSize(snap(box.width), isCircle ? Math.min(maxWidth, maxHeight) : maxWidth)
	const height = isCircle ? width : clampSize(snap(box.height), maxHeight)

	node.setAttrs({
		x: isCircle ? x + width / 2 : x,
		y: isCircle ? y + height / 2 : y,
		scaleX: (node.scaleX() * width) / box.width,
		scaleY: (node.scaleY() * height) / box.height
	})

	return { x, y, width, height }
}
